import { render, staticRenderFns } from "./ProfessionalInfoTalentFind.vue?vue&type=template&id=2d5472a8"
import script from "./ProfessionalInfoTalentFind.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoTalentFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports